import styled, { css } from 'styled-components';

export const NavLink = styled.a`
  ${props => props.theme.typography.heading3};
  color: ${props => props.theme.colors.text.primary};
  background-color: transparent;
  margin: ${props => props.theme.spacing(0, 3)};
  outline: none;
  border: none;
  padding: ${props => props.theme.spacing(3, 0)};
  display: inline;

  &:focus {
    text-decoration: none;
    outline: 1px solid ${props => props.theme.colors.text.primary};
    border-radius: 2px;
    border: none;
  }

  @media ${props => props.theme.laptop} {
    ${props => props.theme.typography.body};

    &:last-child {
      margin-right: 0;
    }

    &:first-child {
      margin-left: 0;
    }
  }
`;

export const SmallNavLink = styled(NavLink)`
  ${props => props.theme.typography.body};
  &:focus {
    outline: 0;
  }
`;

export const Header = styled.header`
  ${props =>
    props.sticky &&
    css`
      position: sticky;
      top: ${props => (!props.stickyBanner && props.hasBanner ? -40 : 0)}px;
      z-index: 100;
    `};
`;

export const StyledHeaderButton = styled.button`
  ${props => props.theme.typography.heading3};
  background: transparent;
  border: none;
  display: inline;
  margin: ${props => props.theme.spacing(0, 3)};
  outline: none;
  padding: ${props => props.theme.spacing(3, 0)};
  color: ${props => props.theme.colors.text.primary};

  &:focus {
    text-decoration: none;
  }

  @media ${props => props.theme.laptop} {
    ${props => props.theme.typography.body};
  }
`;
